import React, { useMemo, useState } from 'react';
import { Input } from 'antd';
import PropTypes from 'prop-types';

import OnTraccrCheckbox from '../common/inputs/OnTraccrCheckbox';
import { includesTerm } from '../helpers/helpers';

export default function WorkflowMarketplaceExportChecklist({
  title,
  items,
  selectedIds,
  onChange,
}) {
  const [filter, setFilter] = useState('');

  const visibleItems = useMemo(() => (
    items.filter((item) => includesTerm(item.label, filter))
  ), [items, filter]);

  const selectedSet = useMemo(() => new Set(selectedIds), [selectedIds]);
  const visibleSelectedCount = visibleItems.filter(({ id }) => selectedSet.has(id)).length;
  const allVisibleSelected = visibleItems.length > 0
    && visibleSelectedCount === visibleItems.length;

  const toggle = (id, checked) => {
    const next = new Set(selectedSet);
    if (checked) next.add(id);
    else next.delete(id);
    onChange(items.filter((item) => next.has(item.id)).map((item) => item.id));
  };

  const toggleAll = (checked) => {
    const next = new Set(selectedSet);
    visibleItems.forEach(({ id }) => (checked ? next.add(id) : next.delete(id)));
    onChange(items.filter((item) => next.has(item.id)).map((item) => item.id));
  };

  return (
    <div className="workflow-marketplace-export-modal-checklist">
      <div className="workflow-marketplace-export-modal-checklist-header">
        <span className="workflow-marketplace-export-modal-checklist-title">{title}</span>
        <span className="workflow-marketplace-export-modal-muted">
          {selectedIds.length} of {items.length}
        </span>
      </div>
      <Input.Search
        placeholder="Filter"
        allowClear
        value={filter}
        onChange={(e) => setFilter(e.target.value)}
      />
      <div style={{ padding: '0 0 8px 4px', borderBottom: '1px solid #E5E7EB' }}>
        <OnTraccrCheckbox
          label="Select all"
          value={allVisibleSelected}
          indeterminate={visibleSelectedCount > 0 && !allVisibleSelected}
          disabled={!visibleItems.length}
          onChange={toggleAll}
        />
      </div>
      <div className="workflow-marketplace-export-modal-checklist-items">
        {visibleItems.map((item) => (
          <div key={item.id} className="workflow-marketplace-export-modal-checklist-item">
            <OnTraccrCheckbox
              value={selectedSet.has(item.id)}
              onChange={(checked) => toggle(item.id, checked)}
              label={(
                <>
                  <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={item.label}>
                    {item.label}
                  </span>
                  <span className="workflow-marketplace-export-modal-muted workflow-marketplace-export-modal-checklist-item-division">
                    {item.division}
                  </span>
                </>
              )}
            />
          </div>
        ))}
        {!visibleItems.length && (
          <div className="workflow-marketplace-export-modal-muted" style={{ padding: '8px 0' }}>
            {items.length ? 'No matches' : `No ${title.toLowerCase()} in this account`}
          </div>
        )}
      </div>
    </div>
  );
}

WorkflowMarketplaceExportChecklist.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    division: PropTypes.string,
  })).isRequired,
  selectedIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
};
